import type { LandingPageContent } from '../types'

export const AYUDAS_FOTOVOLTAICA: LandingPageContent = {
  slug: 'ayudas-fotovoltaica',
  lang: 'es',
  topicId: 'photovoltaik-foerderung',
  title: 'Ayudas para fotovoltaica en Alemania: KfW, tarifa de alimentación y subvenciones',
  metaDescription:
    'Ayudas a nivel federal, estatal y municipal en Alemania - y cómo comparar presupuestos de ' +
    'forma justa a pesar de ello. Actualizado: agosto de 2026, revisar cada año.',
  keywords: [
    'ayudas fotovoltaica alemania',
    'kfw fotovoltaica',
    'tarifa de alimentación einspeisevergütung',
    'subvención fotovoltaica alemania',
    'impuestos fotovoltaica alemania',
    'ayuda batería solar',
  ],
  eyebrow: 'Ayudas · Actualizado: agosto de 2026',
  h1: 'Ayudas para fotovoltaica en Alemania: lo importante en 2026',
  intro:
    'Las ayudas cambian el precio final real de una instalación solar a menudo más que cualquier ' +
    'negociación de precio. Esta página resume los puntos clave a nivel federal en Alemania y ' +
    'explica por qué las ayudas no cambian nada en la comparación justa de presupuestos.',
  sections: [
    { type: 'heading', text: 'Nivel federal: los puntos clave' },
    {
      type: 'list',
      items: [
        '0% de IVA en la compra e instalación de instalaciones fotovoltaicas pequeñas - vigente de forma indefinida',
        'Los ingresos de instalaciones fotovoltaicas privadas de hasta 30 kWp están exentos del impuesto sobre la renta - no requiere alta de actividad',
        'Tarifa de alimentación (Einspeisevergütung) del EEG: importe fijo por kWh durante 20 años desde la puesta en marcha, la cuantía baja periódicamente para las instalaciones nuevas - empezar antes suele asegurar una tarifa más alta',
        'Crédito KfW 270: financiación a bajo interés, las condiciones cambian continuamente',
      ],
    },
    { type: 'heading', text: 'Cambio importante a partir de 2027: reforma del EEG anunciada' },
    {
      type: 'paragraph',
      text:
        'El Ministerio Federal de Economía alemán ha anunciado en un anteproyecto que la tarifa fija ' +
        'de alimentación para instalaciones nuevas de hasta 25 kWp se eliminaría a partir de 2027 - ' +
        'los titulares comercializarían su excedente directamente en la bolsa de electricidad. A ' +
        'fecha de agosto de 2026 es un anteproyecto, no una ley aprobada definitivamente - quien ' +
        'ponga en marcha una instalación en 2026 se asegura la tarifa fija vigente en ese momento ' +
        'durante los 20 años completos, independientemente de la reforma.',
    },
    { type: 'heading', text: 'Estados federados y municipios: muy diferente según la región' },
    {
      type: 'paragraph',
      text:
        'Solo una parte de los estados federados (Bundesländer) tiene actualmente programas de ' +
        'ayudas propios - varios programas estatales anteriores se cerraron sin sucesor. Las ' +
        'subvenciones municipales (a veces hasta importes de cinco cifras bajas, muy diferente según ' +
        'el municipio) suelen ser el nivel más relevante. Una visión general actualizada, filtrable ' +
        'por estado federado y colectivo, la ofrece la base de datos pública de ayudas del Estado ' +
        'alemán (foerderdatenbank.de) - ahí encontrará los programas realmente vigentes para su ' +
        'domicilio, más actualizados de lo que puede estarlo cualquier lista estática.',
    },
    { type: 'heading', text: 'Qué significa esto para su comparación de presupuestos' },
    {
      type: 'paragraph',
      text:
        'Las ayudas no cambian la lógica básica de la comparación: el criterio justo sigue siendo el ' +
        'precio antes de ayudas, porque las ayudas se aplican independientemente de la empresa ' +
        'instaladora elegida. En Roofora compare primero presupuestos con precio fijo sin compromiso ' +
        'de varias empresas - solo después merece la pena mirar las ayudas que le corresponden.',
    },
  ],
  faq: [
    {
      q: '¿Debo solicitar la ayuda antes o después de recibir los presupuestos?',
      a: 'En prácticamente todos los programas estatales y municipales, la solicitud de ayuda debe presentarse antes de comprar o instalar la instalación - planifíquelo en cuanto tenga los primeros presupuestos, no después de adjudicar el encargo.',
    },
    {
      q: '¿Por qué esta página no detalla las tarifas de ayuda por estado federado?',
      a: 'Porque los programas estatales y municipales cambian continuamente y no podemos mantener una base de datos propia fiable y actualizada para ello - la base de datos oficial de ayudas del Estado (foerderdatenbank.de) es la fuente fiable y actualizada al día para eso.',
    },
    {
      q: '¿Cambia mi tarifa de alimentación retroactivamente si cambia la ley?',
      a: 'No - la tarifa vigente en el momento de la puesta en marcha se mantiene fija durante 20 años, independientemente de cambios legales posteriores para instalaciones nuevas.',
    },
  ],
  primaryCta: { label: 'Comparar presupuestos gratis ahora', action: 'customer' },
  secondaryCta: { label: 'Cómo calculamos el precio orientativo', action: 'link', href: '/como-calculamos-el-precio' },
  relatedLinks: [
    { label: '¿Cuánto cuesta una instalación solar?', href: '/coste-instalacion-fotovoltaica' },
    { label: 'Cómo funciona la comparación de presupuestos', href: '/comparar-presupuestos-fotovoltaicos' },
  ],
}
